import { For } from "solid-js";
import { wrapEstateLabel } from "./estateText";
import type { EstateBand } from "./estateTypes";

export function EstateClusterBand(props: {
  band: EstateBand;
  compact: boolean;
  active: boolean;
}) {
  const titleLines = () =>
    wrapEstateLabel(
      props.band.label,
      Math.max(12, Math.floor((props.band.width - 7) / 0.66)),
    );
  const scoreLabel = () =>
    props.band.averageScore === null
      ? "Not scored"
      : `Avg ${props.band.averageScore}`;
  const hotspotLabel = () => {
    const labels = [];
    if (props.band.weakPages > 0) {
      labels.push(
        `${props.band.weakPages} ${props.band.weakPages === 1 ? "needs" : "need"} attention`,
      );
    }
    if (props.band.importantPages > 0) {
      labels.push(`${props.band.importantPages} with priority issues`);
    }
    return labels.join(" / ");
  };

  return (
    <g
      class={`signal-cluster-band ${props.active ? "is-active" : ""}`}
      data-cluster-key={props.band.key}
    >
      <title>{`${props.band.label}: ${props.band.pageCount} ${
        props.band.pageCount === 1 ? "page" : "pages"
      }, ${scoreLabel()}${hotspotLabel() ? `, ${hotspotLabel()}` : ""}`}</title>
      <rect
        class="signal-cluster-surface"
        x={props.band.x}
        y={props.band.y}
        width={props.band.width}
        height={props.band.height}
        rx="1.65"
      />
      <line
        class="signal-cluster-divider"
        x1={props.band.x}
        y1={props.band.y + 7}
        x2={props.band.x + props.band.width}
        y2={props.band.y + 7}
      />
      <text
        class="signal-cluster-title"
        x={props.band.x + 1.7}
        y={props.band.y + 2.35}
      >
        <For each={titleLines()}>
          {(line, index) => (
            <tspan x={props.band.x + 1.7} dy={index() === 0 ? 0 : 1.38}>
              {line}
            </tspan>
          )}
        </For>
      </text>
      <text
        class="signal-cluster-count"
        x={props.band.x + props.band.width - 1.55}
        y={props.band.y + 2.35}
        text-anchor="end"
      >
        {props.band.pageCount} {props.band.pageCount === 1 ? "page" : "pages"}
      </text>
      <text
        class="signal-cluster-score"
        x={props.band.x + 1.7}
        y={props.band.y + 5.55}
      >
        {scoreLabel()}
      </text>
      <text
        class="signal-cluster-hotspots"
        x={props.band.x + props.band.width - 1.55}
        y={props.band.y + 5.55}
        text-anchor="end"
      >
        {hotspotLabel() || (props.compact ? "No current hotspots" : "")}
      </text>
    </g>
  );
}
